import { Fragment } from "react/jsx-runtime";
import HeroSection from "../components/common/HeroSection";
import data from "../aboutClinic.json";
import OurClinic from "../components/AboutClinic/OurClinic";
import ImageCardGrid from "../components/common/WhyImageCard";
import LocationContact from "../components/AboutClinic/LocationContact";
import DigitalHealthFAB from "../components/Digitalhealth";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import {
  splitClinicTiming,
  useClinicSchedule,
} from "../context/ClinicScheduleContext";
import useFetch from "../hooks/useFetch";
import { BASE_URL } from "../api/apiClient";
import { formatTime } from "../components/OurDoctors/Book Consultation";


const AboutClinic = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const timer = setTimeout(() => {
      document
        .getElementById(id)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
    return () => clearTimeout(timer);
  }, [location.hash]);
  const { schedule } = useClinicSchedule();
  const weeklySchedule = schedule?.schedulingSetup?.weeklySchedule;
    const workingDays = weeklySchedule?.filter((day) => day.working);

  const formatClinicTimings = (weeklySchedule) => {
    if (!weeklySchedule?.length) return "";
    const dayMap = {
      MONDAY: "Monday",
      TUESDAY: "Tuesday",
      WEDNESDAY: "Wednesday",
      THURSDAY: "Thursday",
      FRIDAY: "Friday",
      SATURDAY: "Saturday",
      SUNDAY: "Sunday",
    };
    const formatTime = (time) => {
      if (!time) return "";
      const [hour, minute] = time.split(":");
      const date = new Date();
      date.setHours(Number(hour), Number(minute));
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    };
    if (!workingDays.length) return "";
    const firstDay = workingDays?.[0];
    const lastDay = workingDays?.[workingDays?.length - 1];
    const startTime = firstDay?.timeWindows?.[0]?.startTime;
    const endTime = firstDay?.timeWindows?.[0]?.endTime;
    const secondShiftStartTime = firstDay?.timeWindows?.[1].startTime;
    const secondShiftEndTime = firstDay?.timeWindows?.[1].endTime;
   
    // return `${dayMap[firstDay.dayOfWeek]}-${dayMap[lastDay.dayOfWeek]} ${formatTime(
    //   startTime
    // )} - ${formatTime(endTime)} | Lunch: ${formatTime(
    //   lunchStart
    // )} - ${formatTime(lunchEnd)} && ${formatTime(secondShiftStartTime)}-${formatTime(secondShiftEndTime)}`;
    return `${dayMap[firstDay.dayOfWeek]}-${dayMap[lastDay.dayOfWeek]} ${formatTime(
      startTime,
    )} - ${formatTime(endTime)} & ${formatTime(secondShiftStartTime)} - ${formatTime(secondShiftEndTime)}`;
  };
  const timings = formatClinicTimings(weeklySchedule);
  console.log(timings,"these r the timingssssssssss");
  const { days, timings: clinicTimings } = splitClinicTiming(timings);
  const offDays = weeklySchedule?.filter((day) => day.working !== true);
  const firstObj = {
    label: `${days}`,
    value: `${clinicTimings}`,
  };
  const secondObj = {
    label: `${offDays?.[0]?.dayOfWeek}`,
    value: "Closed",
  };
  const{data:aboutApiData}=useFetch(`${BASE_URL}/api/femcare/about/?clinic=mukta`);
  console.log(schedule,"this is the dattttttttta");
console.log(aboutApiData?.aboutHero?.hero,"hhhhhhhhhhhero");
const heroDataFromApi=[aboutApiData?.aboutHero?.hero]
  const rowsTobeMapped = [firstObj, secondObj];
    const firstDay = workingDays?.[0];
   const lunchStart = firstDay?.lunchBreak?.startTime;
    const lunchEnd = firstDay?.lunchBreak?.endTime;
  const lunchText=`Break Hour : ${formatTime(lunchStart)} - ${formatTime(lunchEnd)}`
  console.log(lunchText,"tttttttttttttt");
if(!aboutApiData) return <>Loading.....</>
  return (
    <Fragment>
      <DigitalHealthFAB />
      <HeroSection slides={heroDataFromApi} />
      <OurClinic  aboutClinic={aboutApiData?.aboutClinic}/>
      <ImageCardGrid data={aboutApiData?.whyOurClinic} />
      <LocationContact lunchText={lunchText} rowsTobeMapped={rowsTobeMapped}  locationContact={aboutApiData.locationContact}/>
    </Fragment>
  );
};

export default AboutClinic;
